import React from 'react';
import { Container, Image } from 'react-bootstrap';

const Banner = () => {
    return (
      
         
               <div>
              
              <img className="img-fluid" src="./image/banner1.png" alt="Girl in a jacket" />
              </div>
             
         
      
    );
};

export default Banner;